<div class="myModal">
  <div class="modal-header">
    <!--la valeur {{titre}} est vide, sur wave s'affiche comme erreur, pareil pour les autres-->
    <!--<h4 class="modal-title" id="modal-basic-title">{{ title | translate }}</h4>-->
    <button  (click)="exitModal(false)" class="close"  aria-label="close">
      Fermer
      <mat-icon aria-hidden="true" inline="true">close</mat-icon>
    </button>
  </div>
  <div class="modal-body">
    <!--la valeur {{contentTitle}} est indifinie-->
    <!--<h2>{{ contentTitle | translate}} </h2>-->
    <p *ngIf="loading" class="loading-message" role="status">
      <span class="spinner-border spinner-border-sm mr-2" aria-hidden="true"></span>
      {{ 'general.chargement_message' | translate }}
    </p>
    <p *ngIf="!loading" style="white-space: pre-line">{{ content | translate }}</p>
    <!--la valeur {{footerTitle}} est indifinie-->
    <!--<h2>{{ footerTitle | translate}} </h2>-->
    <!--la valeur {{link}} est indifinie-->
    <!--<a href="{{ url }}" target="_blank">{{ link | translate }}</a>-->
  </div>
  <div class="modal-footer" *ngIf="OkOuRetour">
    <button aria-label="confirmer" (click)="exitModal(true)" class="btn btn-outline-primary">Confirmer le choix</button>
    <button aria-label="retour" (click)="exitModal(false)" class="btn btn-outline-primary">Retour</button>
  </div>
  <div class="modal-footer" *ngIf="valider">
    <button aria-label="Annuler" (click)="exitModal(true)" class="btn btn-outline-primary mr-auto" >Annuler</button>
    <button aria-label="Valider" (click)="exitModal(false)" class="btn btn-primary ml-3">Valider</button>
  </div>
  <div class="modal-footer" *ngIf="retour">
    <button aria-label="retour" (click)="exitModal(false)" class="btn btn-outline-primary">Retour</button>
  </div>
</div>
